import pMemoize from "@-/com.npmjs.p-memoize";
import type { HanziScript } from "@-/dev.improve.haniverse.lib.actor.types";

export type HanziScriptConverter = (text: string) => string;

export type HanziScriptConverters = {
  simplifiedToTraditional: HanziScriptConverter;
  traditionalToSimplified: HanziScriptConverter;
};

// Dictionaries are immutable and independent of accounts and QueryClients. Cache the
// lazy construction itself so cache eviction, refetches and root replacement cannot
// build another multi-megabyte copy while an earlier reader still owns the first.
export const loadHanziScriptConverters = pMemoize(async (): Promise<HanziScriptConverters> => {
  const { createPackedHanziScriptConverters } = await import("#packed-hanzi-script-converters");
  return createPackedHanziScriptConverters();
});

export function convertCharacter(
  character: string,
  fromScript: HanziScript,
  toScript: HanziScript,
  converters: HanziScriptConverters,
): string {
  if (fromScript === toScript) {
    return character;
  }
  const convert =
    fromScript === "traditional"
      ? converters.traditionalToSimplified
      : converters.simplifiedToTraditional;
  return convert(character);
}
